import { TAccount } from './accounts.types';

export const getAccountIsRCF = (account: TAccount) => {
    if (!account.formal_offer_access_period) return false;

    const accessPeriodOfferId = account.formal_offer_access_period.offer_id;
    const accesPeriodFormalOffer = account.formal_offers.find(
        (offer) => offer.offer_id === accessPeriodOfferId
    );

    if (!accesPeriodFormalOffer) return false;

    return accesPeriodFormalOffer.interest_only_repayments === 12;
};
